import { defineStore } from 'pinia'
import { $themeConfig } from '@themeConfig'

export const useAppConfigStore = defineStore('AppConfigStore', {
  state: () => ({
    layout: {
      isRTL: $themeConfig.layout.isRTL,
      skin: localStorage.getItem('vuexy-skin') || $themeConfig.layout.skin,
      userdata: localStorage.getItem('userData'),
      routerTransition: $themeConfig.layout.routerTransition,
      type: $themeConfig.layout.type,
      contentWidth: $themeConfig.layout.contentWidth,
      menu: {
        hidden: $themeConfig.layout.menu.hidden,
      },
      navbar: {
        type: $themeConfig.layout.navbar.type,
        backgroundColor: $themeConfig.layout.navbar.backgroundColor,
      },
      footer: {
        type: $themeConfig.layout.footer.type,
      },
    },
  }),
  actions: {
    toggleRtl() {
      this.layout.isRTL = !this.layout.isRTL
      document.documentElement.setAttribute('dir', this.layout.isRTL ? 'rtl' : 'ltr')
    },
    updateSkin(skin) {
      this.layout.skin = skin
      localStorage.setItem('vuexy-skin', skin)

      if (skin === 'dark') document.body.classList.add('dark-layout')
      else if (document.body.className.match('dark-layout')) document.body.classList.remove('dark-layout')
    },
    updateUserdata(val) {
      this.layout.userdata = val
      if (val === null || val === undefined) {
        localStorage.removeItem('userData')
      } else {
        localStorage.setItem('userData', val)
      }
    },
    updateRouterTransition(val) {
      this.layout.routerTransition = val
    },
    updateLayoutType(val) {
      this.layout.type = val
    },
    updateContentWidth(val) {
      this.layout.contentWidth = val
    },
    updateNavMenuHidden(val) {
      this.layout.menu.hidden = val
    },
    updateNavbarConfig(obj) {
      Object.assign(this.layout.navbar, obj)
    },
    updateFooterConfig(obj) {
      Object.assign(this.layout.footer, obj)
    },
  },
})
